module.exports = __webpack_public_path__ + "static/img/b2.0343705.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b2.png
// module id = lxTt
// module chunks = 1